<template>
  <tr class="text-xs-center hovereable">
    <td width="120">
      <v-icon x-large class="k-orange-linear-text text--darken-2">
      {{ icon }}
      </v-icon>
    </td>
    <td class="text-xs-left">
      {{ item.name }}
      <small>
        <template v-if="item.channel_id !== 1">
          <div class="word-wrap">
            {{ item.text }}
          </div>
        </template>
      </small>
    </td>
    <td>
      Orden: {{ item.order || 'Sin especificar' }}
    </td>
    <td class="text-xs-right">
      <v-chip medium class="green white--text" v-if="item.status === 'activo'">
        <v-icon class="pr-2 white--text" small>fas fa-check</v-icon>
        Activo
      </v-chip>
      <v-chip medium class="grey darken-0 white--text" v-if="item.status === 'inactivo'">
        <v-icon class="pr-2 white--text" small>fas fa-user-slash</v-icon>
        Inactivo
      </v-chip>
    </td>
    <td class="text-xs-right">
      <v-menu left offset-x>
        <v-btn color="black" icon flat slot="activator">
          <v-icon small>fas fa-ellipsis-v</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="openEdit">
            <v-list-tile-title>
              Editar
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="toggleStatus">
            <v-list-tile-title>
              <template v-if="item.status === 'activo'">
                Desactivar
              </template>
              <template v-else>
                Activar
              </template>
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="deleteItem">
            <v-list-tile-title>Eliminar</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </td>
  </tr>
</template>

<script>
import EventBus from '@/event-bus';
import ChannelMixins from '@/mixins/channelsV2';

export default {
    mixins: [
      ChannelMixins,
    ],
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {};
    },
    computed: {
      icon() {
        return (this.channels.find(x => x.id === this.item.channel_id) || {} ).icon || 'fas fa-question'
      },
    },
    methods: {
      openEdit() {
        this.$emit('edit', this.item);
      },
      toggleStatus() {
        let status = '';
        if (this.item.status.toLowerCase() === 'activo') {
          status = 'inactivo';
        } else {
          status = 'activo';
        }
        this.axios.patch(`answer_templates/${this.item.id}`, { status }).then(() => {
          this.$emit('update');
        }).catch(() => {});
      },
      deleteItem() {
        EventBus.$emit('deleteItem', this.item.id, this.item.name);
      },
    },
  };

</script>

<style scoped>
  .hovereable {
    background-color: rgba(0, 0, 0, .05) !important;
    cursor: pointer;
  }

  .hovereable:hover {
    background-color: rgba(0, 0, 0, .05) !important;
    cursor: pointer;
  }

  .text-right {
    text-align: right;
  }

</style>



// WEBPACK FOOTER //
// src/components/chat_center_v2/config/AnswerTemplateItem.vue